import { useEffect, useState } from 'react';

function useWindowSize(subtractHeight = 0) {
    const [size, setSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight - subtractHeight,
    });

    useEffect(() => {
        const handleResize = () => {
            setSize({
                width: window.innerWidth,
                height: window.innerHeight - subtractHeight,
            });
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [subtractHeight]);

    return size;
}

export default useWindowSize;
